import { cx } from '@libs/classnames';
import { FancyBadge } from '@ui/components/FancyBadge';
import { CameraIcon } from '@ui/icons/CameraIcon';
import { MicIcon } from '@ui/icons/MicIcon';
import { OnAirIcon } from '@ui/icons/OnAirIcon';

import { VideoSource } from '@features/game/ui/GameButtons/GameButtons';
import { RoomStatus } from '@features/video/types';
import { StreamStatus } from '@features/video/ui/StreamStatus';

import styles from './TournamentVideoCard.module.css';

export type Props = {
  className?: string;
  source: VideoSource;
  // состояние комнаты, когда снимает это устройство
  status?: RoomStatus;
  // чего-то не хватает, например второй камеры
  accent?: boolean;
  // связь с комнатой порвалась
  error?: boolean;
  // микрофон или камера выключены в эфире: вместо «в эфире» перечеркнутые значки, клик
  // по ним открывает настройки
  micOff?: boolean;
  camOff?: boolean;
  onOpen: () => void;
};

// Плашка видеоконтроля на странице турнира: одна строка на всю ширину
export function TournamentVideoCard({
  className,
  source,
  status,
  accent,
  error,
  micOff,
  camOff,
  onOpen,
}: Props) {
  const needsSetup = source === 'none';
  const isDevice = source === 'device' && !error;
  const isLive = isDevice && status === 'live';

  return (
    <section className={cx(styles.card, { [styles.is_error]: error }, className)}>
      {error ? (
        <CameraIcon className={styles.card__icon} off />
      ) : isLive && (camOff || micOff) ? (
        <button
          type="button"
          className={styles.card__off}
          title="Открыть настройки видео"
          onClick={onOpen}
        >
          {camOff && <CameraIcon className={cx(styles.card__icon, styles.is_live)} off />}
          {micOff && <MicIcon className={cx(styles.card__icon, styles.is_live)} off />}
        </button>
      ) : isLive ? (
        <OnAirIcon className={cx(styles.card__icon, styles.is_live)} />
      ) : (
        <CameraIcon className={styles.card__icon} />
      )}

      <h3 className={styles.card__title}>{error ? 'Нет связи' : 'Видеоконтроль'}</h3>

      {needsSetup && <p className={styles.card__text}>Для участия нужна видеотрансляция</p>}
      {source === 'other' && <p className={styles.card__text}>Трансляция с другого устройства</p>}
      {isDevice && status && <StreamStatus status={status} />}

      <FancyBadge
        className={cx(styles.card__action, { [styles.is_accent]: needsSetup || accent })}
        onClick={onOpen}
      >
        {needsSetup ? 'Настроить видео' : 'Открыть'}
      </FancyBadge>
    </section>
  );
}
